<template>
    <div class="wrap">
        <div class="container lnb">
            <div class="contents_wrap">
                <div class="contents">
                    <div class="title">
                        {{ this.$route.meta.title }}
                        <div class="clear"></div>
                    </div>
<!--                    <item-list-component :parentType="'theme'" :setData="setData"></item-list-component>
                    <theme-item-component :setData="setData"></theme-item-component>-->
                    <magazine-item-component :magazineKey="magazineKey"></magazine-item-component>
                    <div class="mt15 text_center">
                        <el-button @click="submitForm()" type="primary">저장</el-button>
                    </div>
                </div>
                <page-footer></page-footer>
            </div>
        </div>
    </div>
</template>

<script>
import MagazineItemComponent from "@/components/magazine/MagazineItemComponent";
import EventBus from "@/mixins/event-bus";

export default {
    name: 'ThemeItem',
    components: {
        MagazineItemComponent,
    },
    mixins: [],
    data() {
        return{
            magazineKey: this.$route.params.p_idx,
        }
    },
    beforeRouteLeave(to, from, next){
        if(to.path === "/auth" && this.$localStorage.get('token')){
            next(false);
        }else{
            return next();
        }
    },
    created() {
    },
    mounted() {
    },
    computed: {
    },
    methods: {
        submitForm() {
            EventBus.$emit('updateMagazineItem')
        },
    },
    beforeDestroy() {
    },
}
</script>
